import { useEffect, useState } from 'react';
import type { ReactNode } from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { AuthApiError, currentAccount } from '@/helpers/authApi';
import type { AccountIdentity } from '@/helpers/authApi';
import { DashboardIdentity } from '@/lib/auth/dashboard-context';

export default function DashboardRouteGuard({ children }: { children: ReactNode }) {
  const [identity, setIdentity] = useState<AccountIdentity | null>(null);
  const [state, setState] = useState<'loading' | 'ready' | 'login' | 'error'>('loading');
  const location = useLocation();
  useEffect(() => {
    let active = true;
    currentAccount().then((value) => { if (active) { setIdentity(value); setState('ready'); } })
      .catch((error) => { if (active) setState(error instanceof AuthApiError && error.status === 401 ? 'login' : 'error'); });
    return () => { active = false; };
  }, []);
  if (state === 'login') return <Navigate to="/login" replace />;
  if (state === 'ready' && identity?.dashboardPages?.includes(location.pathname.replace(/\/$/, '') || '/')) {
    return <DashboardIdentity.Provider value={identity}>{children}</DashboardIdentity.Provider>;
  }
  return <main className="p-6 text-foreground-950">
    <p role={state === 'loading' ? 'status' : 'alert'}>{state === 'loading' ? 'Checking access...' : state === 'error'
      ? 'Unable to check your session. Please try again.' : 'Your role does not have access to this page.'}</p>
    {state !== 'loading' && <Link className="inline-flex min-h-11 items-center text-primary-700 underline" to={identity?.dashboardPages?.[0] ?? '/account'}>Back to your dashboard</Link>}
  </main>;
}
